const geraStringAleatoria = (length: number) => {
  let stringAleatoria = '';
  const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  Array.from({ length }).forEach(() => {
    stringAleatoria += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
  });

  return stringAleatoria;
};

const gerarInteiroAleatorio = (min: number, max: number) => {
  const a = Math.ceil(min);
  const b = Math.floor(max);
  return Math.floor(Math.random() * (b - a)) + a;
};

const aguarde = <D>(time: number, data?: D) => new Promise((resolv) => {
  setInterval(() => resolv(data || 'Resolv'), time);
});

export default {
  geraStringAleatoria,
  gerarInteiroAleatorio,
  aguarde,
};
